import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Navigation from './components/Navigation';
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import VehiclesPage from './pages/VehiclesPage';
import TestimonialsPage from './pages/TestimonialsPage';
import ContactPage from './pages/ContactPage';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import SeoLandingPage from './components/SeoLandingPage';
import seoPages from './data/seoPages';
import vehiclePages from './data/vehiclePages';
import departmentPages from './data/departmentPages';
import BlogIndex from './components/BlogIndex';
import BlogPost from './components/BlogPost';
import { ReservationProvider } from './contexts/ReservationContext';
import ReservationModal from './components/ReservationModal';
import NotFoundPage from './pages/NotFoundPage';

function App() {
  const location = useLocation();

  // Envoi d'une page vue à GA4 à chaque changement de route (si GA est configuré)
  useEffect(() => {
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'page_view', {
        page_path: location.pathname + location.search,
        page_title: document.title
      });
    }
  }, [location]);

  return (
    <ReservationProvider>
      <div className="App">
        <Helmet>
          <html lang="fr-FR" />
          <title>VIP Limousine Paris - Location de Limousine avec Chauffeur 24/7 | Île-de-France</title>
          <meta name="description" content="VIP Limousine Paris ★ Location de limousine de luxe avec chauffeur privé à Paris et en Île-de-France. Mariages, transferts aéroport, soirées VIP, événements 24/7." />
          <link rel="canonical" href="https://limousine-vip-paris.fr/" />
        </Helmet>

        <Navigation />

        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/vehicules" element={<VehiclesPage />} />
            <Route path="/temoignages" element={<TestimonialsPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/blog" element={<BlogIndex />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            {seoPages.map((page) => (
              <Route
                key={page.slug}
                path={page.slug}
                element={<SeoLandingPage data={page} />}
              />
            ))}
            {vehiclePages.map((page) => (
              <Route
                key={page.slug}
                path={page.slug}
                element={<SeoLandingPage data={page} />}
              />
            ))}
            {departmentPages.map((page) => (
              <Route
                key={page.slug}
                path={page.slug}
                element={<SeoLandingPage data={page} />}
              />
            ))}
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>

        <Footer />
        <WhatsAppButton />
        <ReservationModal />
      </div>
    </ReservationProvider>
  );
}

export default App;
